
import { useState, useEffect } from 'react';
import Header from './components/Header';
import VideoGrid from './components/VideoGrid';
import Footer from './components/Footer';
import QuoteForm from './components/QuoteForm';

const HomePage = () => {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 2000);

    return () => clearTimeout(timer);
  }, []);

  if (isLoading) {
    return (
      <div className="fixed inset-0 bg-[#111111] flex items-center justify-center z-50">
        <div className="text-center">
          <div className="w-16 h-16 border-2 border-[#C0C0C0] border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
          <div className="text-[#C0C0C0] text-lg font-light tracking-wider">SKYVIEW</div>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-[#111111] text-white overflow-x-hidden">
      <Header />
      <VideoGrid />
      <QuoteForm />
      <Footer />
    </div>
  );
};

export default HomePage;
